import { render, staticRenderFns } from "./SurveyLinkCard.vue?vue&type=template&id=20682f16&scoped=true&"
import script from "./SurveyLinkCard.vue?vue&type=script&lang=js&"
export * from "./SurveyLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyLinkCard.vue?vue&type=style&index=0&id=20682f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20682f16",
  null
  
)

export default component.exports